import { render, staticRenderFns } from "./FormPaymentMethods.vue?vue&type=template&id=27c01fab"
import script from "./FormPaymentMethods.vue?vue&type=script&lang=js"
export * from "./FormPaymentMethods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports